import {
  uniqueNamesGenerator,
  adjectives,
  NumberDictionary,
  animals,
} from "unique-names-generator";
import { initializeApp } from "firebase/app";
import {
  getStorage,
  ref as refs,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { getDatabase, ref, get, set } from "firebase/database";
import {
  getAuth,
  signInWithPopup,
  signInWithCredential,
  signOut,
  GoogleAuthProvider,
  FacebookAuthProvider,
  TwitterAuthProvider,
} from "firebase/auth";
import Cookies from "js-cookie";
import en from "javascript-time-ago/locale/en";
import TimeAgo from "javascript-time-ago";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  databaseURL: process.env.REACT_APP_DATABASEURL,
};

initializeApp(firebaseConfig);
TimeAgo.addDefaultLocale(en);
const auth = getAuth();

function getProvider1(provider) {
  if (provider === "google") {
    return new GoogleAuthProvider();
  } else if (provider === "facebook") {
    return new FacebookAuthProvider();
  } else if (provider === "twitter") {
    return new TwitterAuthProvider();
  }
}

function getProvider2(provider) {
  if (provider === "google") {
    return GoogleAuthProvider;
  } else if (provider === "facebook") {
    return FacebookAuthProvider;
  } else if (provider === "twitter") {
    return TwitterAuthProvider;
  }
}

function getCredential(provider, accessToken, accessTokenSecret) {
  if (provider === "google") {
    return GoogleAuthProvider.credential(null,accessToken);
  } else if (provider === "facebook") {
    return FacebookAuthProvider.credential(accessToken);
  } else if (provider === "twitter") {
    return TwitterAuthProvider.credential(accessToken, accessTokenSecret);
  }
}

function updateAvatar(uid, file) {
  return new Promise((resolve, reject) => {
    const db = getDatabase();
    const usersRef = ref(db, "users/" + uid);
    get(usersRef)
      .then((userSnapshot) => {
        if (userSnapshot.exists()) {
          const storage = getStorage();
          const storageRef = refs(storage, "photo-profile/" + uid);
          uploadBytes(storageRef, file)
            .then((fileSnapshot) => {
              getDownloadURL(refs(storage, fileSnapshot.metadata.fullPath))
                .then((url) => {
                  set(usersRef, {
                    username: userSnapshot.val().username,
                    fullName: userSnapshot.val().fullName,
                    email: userSnapshot.val().email,
                    provider: userSnapshot.val().provider,
                    uid: userSnapshot.val().uid,
                    messages: userSnapshot.val().messages,
                    avatarUrl: url,
                  });
                  resolve(url);
                })
                .catch((error) => reject(error));
            })
            .catch((error) => reject(error));
        }
      })
      .catch((error) => {});
  });
}

function updateUsername(uid, newUsername) {
  return new Promise((resolve, reject) => {
    const db = getDatabase();
    const usersRef = ref(db, "users/" + uid);
    get(usersRef)
      .then((result) => {
        if (result.exists()) {
          set(usersRef, {
            username: newUsername,
            fullName: result.val().fullName,
            email: result.val().email,
            provider: result.val().provider,
            uid: result.val().uid,
            messages: result.val().messages,
            avatarUrl: result.val().avatarUrl,
          }).then((snapshot) => resolve(snapshot));
        }
      })
      .catch((error) => {});
  });
}

function updateFullname(uid, newFullname) {
  return new Promise((resolve, reject) => {
    const db = getDatabase();
    const usersRef = ref(db, "users/" + uid);
    get(usersRef)
      .then((result) => {
        if (result.exists()) {
          set(usersRef, {
            username: newFullname,
            fullName: result.val().fullName,
            email: result.val().email,
            provider: result.val().provider,
            uid: result.val().uid,
            messages: result.val().messages,
            avatarUrl: result.val().avatarUrl,
          }).then((snapshot) => resolve(snapshot));
        }
      })
      .catch((error) => {});
  });
}

function checkUser(provider, accessToken, accessTokenSecret) {
  return new Promise((resolve, reject) => {
    if (provider && accessToken && accessTokenSecret) {
      const credential = getCredential(
        provider,
        accessToken,
        accessTokenSecret
      );
      try {
        signInWithCredential(auth, credential)
          .then((userCredential) => {
            const userData = userCredential.user;
            const db = getDatabase();
            const usersRef = ref(db, "users/" + userData.uid);
            get(usersRef)
              .then((snapshot) => {
                if (snapshot.exists() && userData.uid === snapshot.val().uid) {
                  resolve(snapshot.val());
                } else {
                  resolve(false);
                }
              })
              .catch((error) => {
                reject(error);
              });
          })
          .catch((error) => {
            handleSignOut();
          });
      } catch (e) {
        console.log(e);
      }
    } else {
      resolve(undefined);
    }
  });
}

function handleSignOut() {
  return new Promise((resolve, reject) => {
    signOut(auth)
      .then(() => {
        Cookies.remove("accessToken", { path: "" });
        Cookies.remove("accessTokenSecret", { path: "" });
        Cookies.remove("accessProvider", { path: "" });
        resolve();
      })
      .catch((error) => reject(error));
  });
}

function signInPopup(provider) {
  signInWithPopup(auth, getProvider1(provider))
    .then((result) => {
      const credential = getProvider2(provider).credentialFromResult(result);
      const token = credential.accessToken;
      const secret = credential.secret;
      const user = result.user;
      Cookies.set("accessToken", token, { expires: 180 });
      Cookies.set("accessTokenSecret", secret, { expires: 180 });
      Cookies.set("accessProvider", provider, { expires: 180 });
      const db = getDatabase();
      const usersRef = ref(db, "users/" + user.uid);
      get(usersRef).then((snapshot) => {
        if (!snapshot.exists()) {
          set(usersRef, {
            username: uniqueNamesGenerator({
              dictionaries: [
                adjectives,
                animals,
                NumberDictionary.generate({ min: 100, max: 999 }),
              ],
              separator: "",
              length: 3,
              style: "capital",
            }),
            fullName: user.displayName,
            email: user.email,
            provider: provider,
            uid: user.uid,
            messages: [
              {
                sender: "Tedidu",
                date: Date.now(),
                message: "Welcome to unknown sender",
                displaysender: true,
              },
            ],
            avatarUrl:
              "https://firebasestorage.googleapis.com/v0/b/unknown-sender.appspot.com/o/photo-profile%2Fdefault.png?alt=media&token=4dc7e9ba-a411-4861-88be-a03461bdac79",
          });
        }
      });
    })
    .catch((error) => {});
}

function pushMessage(uid, sender = "unknown", message) {
  return new Promise((resolve, reject) => {
    if (message === "") {
      reject("Message cannot be empty");
    } else {
      const db = getDatabase();
      const usersRef = ref(db, "users/" + uid + "/messages");
      get(usersRef).then((snapshot) => {
        if (snapshot.exists()) {
          const nextIndex = snapshot.val().length;
          const dataMessage = {
            sender: sender,
            message: message,
            date: Date.now(),
            displaysender: false,
          };
          set(ref(db, "users/" + uid + "/messages/" + nextIndex), dataMessage)
            .then((result) => {
              resolve(result);
            })
            .catch((error) => reject(error));
        }
      });
    }
  });
}

export {
  checkUser,
  handleSignOut,
  signInPopup,
  updateAvatar,
  updateUsername,
  updateFullname,
  pushMessage,
};
